import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, XCircle, CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BeforeAfterSection() {
  return <section className="py-24 px-4 bg-dark-bg relative" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-17">
            Tu Transformación Te Espera
          </h2>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-center justify-center mb-16" data-id="element-18">
          {/* BEFORE Card */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full max-w-md bg-dark-surface/50 border border-red-900/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-19">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900 to-transparent" data-id="element-20" />
            <h3 className="text-2xl font-bold text-gray-400 mb-6 flex items-center gap-3" data-id="element-21">
              <span className="bg-red-900/20 p-2 rounded-lg text-red-400" data-id="element-22">
                ANTES
              </span>
              <span className="text-sm font-normal" data-id="element-23">Sin el MegaPack</span>
            </h3>
            <ul className="space-y-4" data-id="element-24">
              {['Energía bloqueada y estancada', 'Estrés y ansiedad constante', 'Desconexión espiritual', 'Dependencia de otros para sanación', 'Sin herramientas ni conocimiento'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-400" data-id="element-25">
                  <XCircle className="w-5 h-5 text-red-500/50 shrink-0" data-id="element-26" />
                  <span data-id="element-27">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Arrow */}
          <div className="hidden md:flex items-center justify-center text-violet-500" data-id="element-28">
            <ArrowRight className="w-12 h-12 animate-pulse" data-id="element-29" />
          </div>
          <div className="md:hidden rotate-90 text-violet-500 my-[-1rem]" data-id="element-30">
            <ArrowRight className="w-12 h-12 animate-pulse" data-id="element-31" />
          </div>

          {/* AFTER Card */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full max-w-md bg-dark-surface border border-violet-500/50 rounded-2xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(139,92,246,0.15)]" data-id="element-32">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-violet-500 to-indigo-500" data-id="element-33" />
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-34">
              <span className="bg-violet-500/20 p-2 rounded-lg text-violet-300" data-id="element-35">
                DESPUÉS
              </span>
              <span className="text-sm font-normal text-gray-300" data-id="element-36">
                Con el MegaPack
              </span>
            </h3>
            <ul className="space-y-4" data-id="element-37">
              {['Energía fluyendo libremente', 'Paz interior y equilibrio', 'Conexión espiritual profunda', 'Autonomía en tu práctica de sanación', 'Maestro/a de Reiki certificado/a'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white" data-id="element-38">
                  <CheckCircle className="w-5 h-5 text-green-400 shrink-0" data-id="element-39" />
                  <span className="font-medium" data-id="element-40">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-41">
          <CTAButton text="¡QUIERO ESTA TRANSFORMACIÓN!" data-id="element-42" />
        </div>
      </div>
    </section>;
}